(function(){try{

      (function() {
        // Cookies to block before consent
        const blockedPatterns = ['_gegeo', '_geran', '_geref', '_gers', '_getdran', '_geuid', '_getd', '_lc2_fpi', '_lc2_fpi_js', 'eabUserId',
         '_li_dcdm_c', '_reidsn', 'lidid', 'uuid', 'ABAU', 'ABTL', 'cf_76396_first_touch', 'cf_76396_id', 'cf_76396_person_last_update'];
        
        // Third-party script domains to block (these set cookies on their domains)
        const blockedScriptDomains = ['liadm.com', 'alocdn.com', 'liveintent.com', 'lijit.com'];
        
        // Track consent state
        window.__ccpaConsentGranted = false;
        window.__ccpaIsRegulatedRegion = true; // Assume regulated until Consentmo tells us otherwise
        
        // Queue to store blocked cookies for later replay
        window.__ccpaBlockedCookieQueue = [];
        
        // Queue to store blocked scripts for later loading
        window.__ccpaBlockedScriptQueue = [];
        
        // Reference to monitoring intervals/callbacks
        let fastIntervalId = null;
        let slowIntervalId = null;
        let monitoringActive = true;
        let monitorCount = 0;
        const MAX_MONITORS = 200;
        
        // Check if URL matches blocked domains
        function isBlockedScriptDomain(url) {
          if (!url) return false;
          try {
            const urlObj = new URL(url, window.location.origin);
            return blockedScriptDomains.some(function(domain) {
              return urlObj.hostname.indexOf(domain) !== -1;
            });
          } catch (e) {
            return blockedScriptDomains.some(function(domain) {
              return url.indexOf(domain) !== -1;
            });
          }
        }
        
        // Block third-party scripts by intercepting script creation
        const originalCreateElement = document.createElement.bind(document);
        document.createElement = function(tagName) {
          const element = originalCreateElement(tagName);
          
          if (tagName.toLowerCase() === 'script') {
            const originalSetAttribute = element.setAttribute.bind(element);
            element.setAttribute = function(name, value) {
              if (name === 'src' && window.__ccpaIsRegulatedRegion && !window.__ccpaConsentGranted) {
                if (isBlockedScriptDomain(value)) {
                  // Store script info for later loading
                  window.__ccpaBlockedScriptQueue.push({
                    src: value,
                    async: element.async,
                    defer: element.defer,
                    type: element.type,
                    id: element.id
                  });
                  // Set a data attribute instead to prevent loading
                  return originalSetAttribute('data-blocked-src', value);
                }
              }
              return originalSetAttribute(name, value);
            };
            
            // Also intercept direct src assignment
            Object.defineProperty(element, 'src', {
              get: function() {
                return element.getAttribute('src') || element.getAttribute('data-blocked-src') || '';
              },
              set: function(value) {
                if (window.__ccpaIsRegulatedRegion && !window.__ccpaConsentGranted && isBlockedScriptDomain(value)) {
                  window.__ccpaBlockedScriptQueue.push({
                    src: value,
                    async: element.async,
                    defer: element.defer,
                    type: element.type,
                    id: element.id
                  });
                  element.setAttribute('data-blocked-src', value);
                  return value;
                }
                element.setAttribute('src', value);
                return value;
              },
              configurable: true
            });
          }
          
          return element;
        };
        
        // Block iframes and scripts via MutationObserver
        const observer = new MutationObserver(function(mutations) {
          if (!window.__ccpaIsRegulatedRegion || window.__ccpaConsentGranted) return;
          
          mutations.forEach(function(mutation) {
            mutation.addedNodes.forEach(function(node) {
              if (node.nodeType !== 1) return; // Only element nodes
              
              // Block iframes
              if (node.tagName === 'IFRAME' && isBlockedScriptDomain(node.src)) {
                node.setAttribute('data-blocked-src', node.src);
                node.removeAttribute('src');
              }
              
              // Block script tags added to DOM
              if (node.tagName === 'SCRIPT' && node.src && isBlockedScriptDomain(node.src)) {
                window.__ccpaBlockedScriptQueue.push({
                  src: node.src,
                  async: node.async,
                  defer: node.defer,
                  type: node.type,
                  id: node.id
                });
                node.setAttribute('data-blocked-src', node.src);
                node.removeAttribute('src');
              }
              
              // Block img pixels from blocked domains
              if (node.tagName === 'IMG' && isBlockedScriptDomain(node.src)) {
                node.setAttribute('data-blocked-src', node.src);
                node.removeAttribute('src');
              }
            });
          });
        });
        
        observer.observe(document.documentElement, { childList: true, subtree: true });
        
        // Intercept fetch requests to blocked domains
        const originalFetch = window.fetch;
        window.__ccpaBlockedFetchQueue = [];
        window.fetch = function(url, options) {
          if (window.__ccpaIsRegulatedRegion && !window.__ccpaConsentGranted) {
            const urlString = typeof url === 'string' ? url : (url.url || url.toString());
            if (isBlockedScriptDomain(urlString)) {
              // Queue the request for later
              window.__ccpaBlockedFetchQueue.push({ url: url, options: options });
              // Return a resolved promise with empty response
              return Promise.resolve(new Response('', { status: 200 }));
            }
          }
          return originalFetch.apply(this, arguments);
        };
        
        // Intercept XMLHttpRequest to blocked domains
        const originalXHROpen = XMLHttpRequest.prototype.open;
        const originalXHRSend = XMLHttpRequest.prototype.send;
        window.__ccpaBlockedXHRQueue = [];
        
        XMLHttpRequest.prototype.open = function(method, url) {
          this.__ccpaBlockedUrl = url;
          this.__ccpaBlockedMethod = method;
          return originalXHROpen.apply(this, arguments);
        };
        
        XMLHttpRequest.prototype.send = function(body) {
          if (window.__ccpaIsRegulatedRegion && !window.__ccpaConsentGranted) {
            if (this.__ccpaBlockedUrl && isBlockedScriptDomain(this.__ccpaBlockedUrl)) {
              window.__ccpaBlockedXHRQueue.push({
                method: this.__ccpaBlockedMethod,
                url: this.__ccpaBlockedUrl,
                body: body
              });
              return; // Don't send the request
            }
          }
          return originalXHRSend.apply(this, arguments);
        };
        
        // Intercept Image src to block tracking pixels
        const originalImageDescriptor = Object.getOwnPropertyDescriptor(HTMLImageElement.prototype, 'src');
        if (originalImageDescriptor) {
          Object.defineProperty(HTMLImageElement.prototype, 'src', {
            get: function() {
              return originalImageDescriptor.get.call(this);
            },
            set: function(value) {
              if (window.__ccpaIsRegulatedRegion && !window.__ccpaConsentGranted && isBlockedScriptDomain(value)) {
                this.setAttribute('data-blocked-src', value);
                return value;
              }
              return originalImageDescriptor.set.call(this, value);
            },
            configurable: true
          });
        }
        
        // Intercept navigator.sendBeacon (used by some trackers)
        const originalSendBeacon = navigator.sendBeacon;
        window.__ccpaBlockedBeaconQueue = [];
        if (originalSendBeacon) {
          navigator.sendBeacon = function(url, data) {
            if (window.__ccpaIsRegulatedRegion && !window.__ccpaConsentGranted && isBlockedScriptDomain(url)) {
              window.__ccpaBlockedBeaconQueue.push({ url: url, data: data });
              return true; // Pretend it was sent
            }
            return originalSendBeacon.apply(navigator, arguments);
          };
        }
        
        // Block existing elements on page load (for elements already in DOM)
        function blockExistingElements() {
          if (!window.__ccpaIsRegulatedRegion || window.__ccpaConsentGranted) return;
          
          // Block existing scripts from blocked domains
          document.querySelectorAll('script[src]').forEach(function(script) {
            if (isBlockedScriptDomain(script.src) && !script.hasAttribute('data-blocked-src')) {
              window.__ccpaBlockedScriptQueue.push({
                src: script.src,
                async: script.async,
                defer: script.defer,
                type: script.type,
                id: script.id
              });
              script.setAttribute('data-blocked-src', script.src);
              script.removeAttribute('src');
            }
          });
          
          // Block existing iframes
          document.querySelectorAll('iframe[src]').forEach(function(iframe) {
            if (isBlockedScriptDomain(iframe.src) && !iframe.hasAttribute('data-blocked-src')) {
              iframe.setAttribute('data-blocked-src', iframe.src);
              iframe.removeAttribute('src');
            }
          });
          
          // Block existing images
          document.querySelectorAll('img[src]').forEach(function(img) {
            if (isBlockedScriptDomain(img.src) && !img.hasAttribute('data-blocked-src')) {
              img.setAttribute('data-blocked-src', img.src);
              img.removeAttribute('src');
            }
          });
        }
        
        // Run blocking on existing elements immediately and after DOM ready
        blockExistingElements();
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', blockExistingElements);
        }
        
        // Delete blocked cookies
        function deleteBlockedCookies() {
          const cookies = document.cookie.split(';');
          const domain = location.hostname;
          
          cookies.forEach(function(c) {
            const name = c.split('=')[0].trim();
            if (blockedPatterns.some(function(p) { return name.indexOf(p) !== -1; })) {
              // Try all combinations of path and domain
              const paths = ['/', '', '/pages', '/collections', '/products'];
              const domains = ['', domain, '.' + domain];
              
              paths.forEach(function(path) {
                domains.forEach(function(d) {
                  const domainPart = d ? '; domain=' + d : '';
                  document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=' + (path || '/') + domainPart;
                  document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=' + (path || '/') + domainPart + '; SameSite=Lax';
                  document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=' + (path || '/') + domainPart + '; SameSite=None; Secure';
                });
              });
            }
          });
        }
        
        // Load blocked scripts after consent
        function loadBlockedScripts() {
          if (window.__ccpaBlockedScriptQueue.length > 0) {
            window.__ccpaBlockedScriptQueue.forEach(function(scriptInfo) {
              const script = originalCreateElement('script');
              if (scriptInfo.async) script.async = true;
              if (scriptInfo.defer) script.defer = true;
              if (scriptInfo.type) script.type = scriptInfo.type;
              if (scriptInfo.id) script.id = scriptInfo.id + '-loaded';
              script.src = scriptInfo.src;
              document.head.appendChild(script);
            });
            window.__ccpaBlockedScriptQueue = [];
          }
          
          // Unblock iframes
          document.querySelectorAll('iframe[data-blocked-src]').forEach(function(iframe) {
            iframe.src = iframe.getAttribute('data-blocked-src');
            iframe.removeAttribute('data-blocked-src');
          });
          
          // Unblock images (tracking pixels)
          document.querySelectorAll('img[data-blocked-src]').forEach(function(img) {
            if (originalImageDescriptor) {
              originalImageDescriptor.set.call(img, img.getAttribute('data-blocked-src'));
            } else {
              img.src = img.getAttribute('data-blocked-src');
            }
            img.removeAttribute('data-blocked-src');
          });
          
          // Replay blocked fetch requests
          if (window.__ccpaBlockedFetchQueue && window.__ccpaBlockedFetchQueue.length > 0) {
            window.__ccpaBlockedFetchQueue.forEach(function(req) {
              originalFetch(req.url, req.options);
            });
            window.__ccpaBlockedFetchQueue = [];
          }
          
          // Replay blocked XHR requests
          if (window.__ccpaBlockedXHRQueue && window.__ccpaBlockedXHRQueue.length > 0) {
            window.__ccpaBlockedXHRQueue.forEach(function(req) {
              const xhr = new XMLHttpRequest();
              originalXHROpen.call(xhr, req.method, req.url);
              originalXHRSend.call(xhr, req.body);
            });
            window.__ccpaBlockedXHRQueue = [];
          }
          
          // Replay blocked sendBeacon requests
          if (window.__ccpaBlockedBeaconQueue && window.__ccpaBlockedBeaconQueue.length > 0 && originalSendBeacon) {
            window.__ccpaBlockedBeaconQueue.forEach(function(req) {
              originalSendBeacon.call(navigator, req.url, req.data);
            });
            window.__ccpaBlockedBeaconQueue = [];
          }
        }
        
        // Replay all queued cookies after consent
        function replayBlockedCookies() {
          const cookieDesc = Object.getOwnPropertyDescriptor(Document.prototype, 'cookie') || 
                            Object.getOwnPropertyDescriptor(HTMLDocument.prototype, 'cookie');
          
          if (cookieDesc && cookieDesc.set && window.__ccpaBlockedCookieQueue.length > 0) {
            
            window.__ccpaBlockedCookieQueue.forEach(function(cookieValue) {
              try {
                cookieDesc.set.call(document, cookieValue);
              } catch (e) {
                console.error('[CCPA] Failed to set cookie:', e);
              }
            });
            
            // Clear the queue after replay
            window.__ccpaBlockedCookieQueue = [];
          }
          
          // Load blocked third-party scripts
          loadBlockedScripts();
        }
        
        // Stop all monitoring
        function stopMonitoring() {
          monitoringActive = false;
          if (fastIntervalId) {
            if ('cancelIdleCallback' in window) {
              cancelIdleCallback(fastIntervalId);
            } else {
              clearTimeout(fastIntervalId);
            }
            fastIntervalId = null;
          }
          if (slowIntervalId) {
            if ('cancelIdleCallback' in window) {
              cancelIdleCallback(slowIntervalId);
            } else {
              clearTimeout(slowIntervalId);
            }
            slowIntervalId = null;
          }
        }

        // Override document.cookie setter to intercept cookies
        const cookieDesc = Object.getOwnPropertyDescriptor(Document.prototype, 'cookie') || 
                          Object.getOwnPropertyDescriptor(HTMLDocument.prototype, 'cookie');
        
        if (cookieDesc && cookieDesc.set) {
          Object.defineProperty(document, 'cookie', {
            get: function() {
              return cookieDesc.get.call(document);
            },
            set: function(value) {
              // Only block if in regulated region AND consent not granted
              if (window.__ccpaIsRegulatedRegion && !window.__ccpaConsentGranted) {
                const cookieName = value.split('=')[0].trim();
                if (blockedPatterns.some(function(p) { return cookieName.indexOf(p) !== -1; })) {
                  
                  // Store the full cookie value for later replay
                  // Check if not already in queue (avoid duplicates)
                  const existingIndex = window.__ccpaBlockedCookieQueue.findIndex(function(c) {
                    return c.split('=')[0].trim() === cookieName;
                  });
                  
                  if (existingIndex >= 0) {
                    // Update existing cookie in queue with new value
                    window.__ccpaBlockedCookieQueue[existingIndex] = value;
                  } else {
                    // Add new cookie to queue
                    window.__ccpaBlockedCookieQueue.push(value);
                  }
                  
                  return value; // Don't actually set it yet
                }
              }
              return cookieDesc.set.call(document, value);
            },
            configurable: true
          });
        }

        // Idle-based monitoring — only deletes cookies when browser is idle,
        // never during user interactions (prevents INP impact).
        // Uses requestIdleCallback with 2s timeout as compliance safety net.
        // Falls back to setTimeout(2000) for browsers without rIC support.
        function scheduleIdleCookieCheck() {
          if (!monitoringActive) return;
          if (monitorCount >= MAX_MONITORS) {
            scheduleSlowMonitoring();
            return;
          }

          if ('requestIdleCallback' in window) {
            fastIntervalId = requestIdleCallback(function() {
              if (!monitoringActive) return;
              if (window.__ccpaIsRegulatedRegion && !window.__ccpaConsentGranted) {
                deleteBlockedCookies();
              }
              monitorCount++;
              scheduleIdleCookieCheck();
            }, { timeout: 2000 });
          } else {
            fastIntervalId = setTimeout(function() {
              if (!monitoringActive) return;
              if (window.__ccpaIsRegulatedRegion && !window.__ccpaConsentGranted) {
                deleteBlockedCookies();
              }
              monitorCount++;
              scheduleIdleCookieCheck();
            }, 2000);
          }
        }

        function scheduleSlowMonitoring() {
          document.addEventListener('visibilitychange', function() {
            if (document.visibilityState === 'visible' && monitoringActive &&
                window.__ccpaIsRegulatedRegion && !window.__ccpaConsentGranted) {
              deleteBlockedCookies();
            }
          });

          function slowCheck() {
            if (!monitoringActive) return;
            if ('requestIdleCallback' in window) {
              slowIntervalId = requestIdleCallback(function() {
                if (!monitoringActive) return;
                if (window.__ccpaIsRegulatedRegion && !window.__ccpaConsentGranted) {
                  deleteBlockedCookies();
                }
                slowCheck();
              }, { timeout: 10000 });
            } else {
              slowIntervalId = setTimeout(function() {
                if (!monitoringActive) return;
                if (window.__ccpaIsRegulatedRegion && !window.__ccpaConsentGranted) {
                  deleteBlockedCookies();
                }
                slowCheck();
              }, 5000);
            }
          }
          slowCheck();
        }

        scheduleIdleCookieCheck();

        // Initial cleanup
        deleteBlockedCookies();
        
        // Export functions for consent handlers
        window.__ccpaEnableCookies = function() {
          window.__ccpaConsentGranted = true;
          
          // Stop monitoring/deleting cookies
          stopMonitoring();
          
          // Replay all blocked cookies that were queued
          replayBlockedCookies();
        };
        
        window.__ccpaDisableCookies = function() {
          window.__ccpaConsentGranted = false;
          deleteBlockedCookies();
          // Restart monitoring if it was previously stopped (e.g. consent revoked after grant)
          if (!monitoringActive) {
            monitoringActive = true;
            monitorCount = 0;
            scheduleIdleCookieCheck();
          }
        };
        
        window.__ccpaSetRegulatedRegion = function(isRegulated) {
          window.__ccpaIsRegulatedRegion = isRegulated;
          if (!isRegulated) {
            window.__ccpaConsentGranted = true;
            
            // Stop monitoring for non-regulated regions
            stopMonitoring();
            
            // Replay any cookies that might have been blocked before region was determined
            replayBlockedCookies();
          }
        };
      })();
    
}catch(e){if(window.console)console.warn('bundled script error',e);}})();
;
(function(){try{

(function() {
  var COOKIE_NAME = 'lang_preference_set';
  var SUPPORTED = ["en","es","de","fr"];
  var DEFAULT_LOCALE = "en";
  var CURRENT_LOCALE = "en";

  function getCookie(name) {
    var m = document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)');
    return m ? m[2] : null;
  }
  function setPrefCookie(value) {
    var d = new Date();
    d.setTime(d.getTime() + 365 * 24 * 60 * 60 * 1000);
    document.cookie = COOKIE_NAME + '=' + value + ';expires=' + d.toUTCString() + ';path=/;SameSite=Lax';
  }

  function attachManualHandlers() {
    var nodes = document.querySelectorAll('button[name="locale_code"]');
    for (var i = 0; i < nodes.length; i++) {
      nodes[i].addEventListener('click', function(e) {
        var v = e.currentTarget.value;
        if (SUPPORTED.indexOf(v) !== -1) setPrefCookie(v);
      }, { passive: true });
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attachManualHandlers, { passive: true });
  } else {
    attachManualHandlers();
  }

  var savedRaw = getCookie(COOKIE_NAME);
  var savedLocale = (savedRaw && SUPPORTED.indexOf(savedRaw) !== -1) ? savedRaw : null;

  // 1. Persistence: served default-locale URL but cookie says non-default → redirect
  if (savedLocale && savedLocale !== DEFAULT_LOCALE && CURRENT_LOCALE === DEFAULT_LOCALE) {
    window.location.replace('/' + savedLocale + window.location.pathname + window.location.search + window.location.hash);
    return;
  }

  // 2. Sync cookie with current page's locale (handles legacy '1' cookie + cross-locale clicks)
  if (CURRENT_LOCALE && SUPPORTED.indexOf(CURRENT_LOCALE) !== -1 && CURRENT_LOCALE !== savedLocale) {
    setPrefCookie(CURRENT_LOCALE);
  }

  // 3. First visit (no cookie at all): auto-detect from browser language on homepage
  if (savedRaw) return;
  if (window.location.pathname !== '/') return;

  var browserLang = (navigator.language || navigator.userLanguage || '').toLowerCase().split('-')[0];
  if (!browserLang || browserLang === CURRENT_LOCALE) return;
  if (SUPPORTED.indexOf(browserLang) === -1 || browserLang === DEFAULT_LOCALE) return;

  setPrefCookie(browserLang);
  window.location.replace('/' + browserLang + '/' + window.location.search + window.location.hash);
})();

}catch(e){if(window.console)console.warn('bundled script error',e);}})();
;
(function(){try{

(function() {
  if (!('PerformanceObserver' in window)) {
    window.getCLSDetails = () => ({ totalCLS: 0, entries: [], topShifts: [] });
    return;
  }
  
  let clsValue = 0;
  let clsEntries = [];
  
  const observer = new PerformanceObserver((list) => {
    for (const entry of list.getEntries()) {
      if (!entry.hadRecentInput) {
        clsValue += entry.value;
        clsEntries.push({
          value: entry.value,
          sources: entry.sources || [],
          startTime: entry.startTime
        });
      }
    }
  });
  
  window.getCLSDetails = () => ({
    totalCLS: clsValue,
    entries: clsEntries,
    topShifts: [...clsEntries].sort((a, b) => b.value - a.value).slice(0, 10)
  });
  
  try {
    observer.observe({ type: 'layout-shift', buffered: true });
  } catch (e) {}
})();

}catch(e){if(window.console)console.warn('bundled script error',e);}})();
;
(function(){try{

  // This allows to expose several variables to the global scope, to be used in scripts
  window.themeVariables = {
    settings: {
      direction: "ltr",
      pageType: "page",
      cartCount: 0,
      moneyFormat: "${{amount}}",
      moneyWithCurrencyFormat: "${{amount}} USD",
      showVendor: false,
      discountMode: "saving",
      currencyCodeEnabled: false,
      searchMode: "product\n  ,article\n  \n  ,collection\n",
      searchUnavailableProducts: "last",
      cartType: "drawer",
      cartCurrency: "USD",
      currencyCode: "USD",
      currencySymbol: "$",
      conversionRate: 1.0,
      mobileZoomFactor: 2.5
    },

    routes: {
      host: "froyaorganics.com",
      rootUrl: "\/",
      rootUrlWithoutSlash: '',
      cartUrl: "\/cart",
      cartAddUrl: "\/cart\/add",
      cartChangeUrl: "\/cart\/change",
      cartUpdateUrl: "\/cart\/update",
      searchUrl: "\/search",
      predictiveSearchUrl: "\/search\/suggest",
      productRecommendationsUrl: "\/recommendations\/products"
    },

    strings: {
      accessibilityDelete: "Delete",
      accessibilityClose: "Close",
      collectionSoldOut: "Sold out",
      collectionDiscount: "You save @savings@",
      productSalePrice: "Sale price",
      productRegularPrice: "Regular price",
      productFormUnavailable: "Unavailable",
      productFormSoldOut: "Sold out",
      productFormPreOrder: "Pre-order",
      productFormAddToCart: "Add to cart",
      searchNoResults: "No results could be found.",
      searchNewSearch: "New search",
      searchProducts: "Products",
      searchArticles: "Journal",
      searchPages: "Pages",
      searchCollections: "Collections",
      cartViewCart: "View cart",
      cartItemAdded: "Item added to your cart!",
      cartItemAddedShort: "Added to your cart!",
      cartAddOrderNote: "Add order note",
      cartEditOrderNote: "Edit order note",
      shippingEstimatorNoResults: "Sorry, we do not ship to your address.",
      shippingEstimatorOneResult: "There is one shipping rate for your address:",
      shippingEstimatorMultipleResults: "There are several shipping rates for your address:",
      shippingEstimatorError: "One or more error occurred while retrieving shipping rates:"
    },

    libs: {
      flickity: "\/\/froyaorganics.com\/cdn\/shop\/t\/207\/assets\/flickity.js?v=176646718982628074891775650485",
      photoswipe: "\/\/froyaorganics.com\/cdn\/shop\/t\/207\/assets\/photoswipe.js?v=132268647426145925301775650485",
      qrCode: "\/\/froyaorganics.com\/cdn\/shopifycloud\/storefront\/assets\/themes_support\/vendor\/qrcode-1f6c2eb7.js"
    },

    breakpoints: {
      phone: 'screen and (max-width: 740px)',
      tablet: 'screen and (min-width: 741px) and (max-width: 999px)',
      tabletAndUp: 'screen and (min-width: 741px)',
      pocket: 'screen and (max-width: 999px)',
      lap: 'screen and (min-width: 1000px) and (max-width: 1199px)',
      lapAndUp: 'screen and (min-width: 1000px)',
      desktop: 'screen and (min-width: 1200px)',
      wide: 'screen and (min-width: 1400px)'
    }
  };

  // Initialize cart on page load
  window.addEventListener('pageshow', async () => {
    const cartContent = await (await fetch(`${window.themeVariables.routes.cartUrl}.js`, {cache: 'reload'})).json();
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {detail: {cart: cartContent}}));
  });


  // Modern browser detection
  if ('noModule' in HTMLScriptElement.prototype) {
    document.documentElement.className = document.documentElement.className.replace('no-js', 'js');

    requestAnimationFrame(() => {
      const viewportHeight = (window.visualViewport ? window.visualViewport.height : document.documentElement.clientHeight);
      document.documentElement.style.setProperty('--window-height', viewportHeight + 'px');
    });
  }
}catch(e){if(window.console)console.warn('bundled script error',e);}})();
;
(function(){try{

!function() {
  const html = document.documentElement;
  const removeLoading = function() {
    html.classList.remove('loading');
    html.classList.add('loaded');
  };
  
  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    removeLoading();
  } else {
    requestAnimationFrame(function() {
      document.addEventListener('DOMContentLoaded', removeLoading, { passive: true, once: true });
      window.addEventListener('load', removeLoading, { passive: true, once: true });
      setTimeout(removeLoading, 1000);
    });
  }
}();

}catch(e){if(window.console)console.warn('bundled script error',e);}})();
;
(function(){try{

(function() {
  function loadDeferredCSS() {
    if ('requestIdleCallback' in window) {
      requestIdleCallback(function() {
        const customCSS = document.createElement('link');
        customCSS.rel = 'stylesheet';
        customCSS.href = '//froyaorganics.com/cdn/shop/t/207/assets/custom.css?v=26511617089700387831779403283';
        document.head.appendChild(customCSS);
        
        const blazeCSS = document.createElement('link');
        blazeCSS.rel = 'stylesheet';
        blazeCSS.href = '//froyaorganics.com/cdn/shop/t/207/assets/blaze.css?v=1372562978454044851778536877';
        document.head.appendChild(blazeCSS);
      }, { timeout: 2000 });
    } else {
      setTimeout(function() {
        const customCSS = document.createElement('link');
        customCSS.rel = 'stylesheet';
        customCSS.href = '//froyaorganics.com/cdn/shop/t/207/assets/custom.css?v=26511617089700387831779403283';
        document.head.appendChild(customCSS);

        const blazeCSS = document.createElement('link');
        blazeCSS.rel = 'stylesheet';
        blazeCSS.href = '//froyaorganics.com/cdn/shop/t/207/assets/blaze.css?v=1372562978454044851778536877';
        document.head.appendChild(blazeCSS);
      }, 2000);
    }
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', loadDeferredCSS, { passive: true });
  } else {
    loadDeferredCSS();
  }
})();

}catch(e){if(window.console)console.warn('bundled script error',e);}})();
;
(function(){try{

!function(e){"use strict";var t=function(t,n,o){var i,r=e.document,a=r.createElement("link");if(o)i=o;else{var l=(r.body||r.getElementsByTagName("head")[0]).childNodes;i=l[l.length-1]}var d=r.styleSheets;a.rel="stylesheet",a.href=t,a.media="only x",function e(t){if(r.body)return t();setTimeout(function(){e(t)})}(function(){i.parentNode.insertBefore(a,o?i:i.nextSibling)});var f=function(e){for(var t=a.href,n=r.styleSheets.length-1;n>=0&&r.styleSheets[n].href!==t;n--);return n>=0&&(a.onload=null,a.media="all"),e};return a.addEventListener&&a.addEventListener("load",f),a.onloadcssdefined=f,f(a),a};"undefined"!=typeof exports?exports.loadCSS=t:e.loadCSS=t}("undefined"!=typeof global?global:this);

}catch(e){if(window.console)console.warn('bundled script error',e);}})();
;
(function(){try{

// Defer polyfills loading until after critical resources
(function() {
  function loadPolyfills() {
    if ('requestIdleCallback' in window) {
      requestIdleCallback(function() {
        const script = document.createElement('script');
        script.src = '//froyaorganics.com/cdn/shop/t/207/assets/polyfills.js?v=98627973986327007531775650486';
        script.defer = true;
        document.head.appendChild(script);
      }, { timeout: 2000 });
    } else {
      // Wait for page load to complete before loading polyfills
      window.addEventListener('load', function() {
        const script = document.createElement('script');
        script.src = '//froyaorganics.com/cdn/shop/t/207/assets/polyfills.js?v=98627973986327007531775650486';
        script.defer = true;
        document.head.appendChild(script);
      }, { passive: true, once: true });
    }
  }
  
  // Only load after DOM is ready and page is interactive
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', loadPolyfills, { passive: true, once: true });
  } else {
    loadPolyfills();
  }
})();

}catch(e){if(window.console)console.warn('bundled script error',e);}})();
;
(function(){try{

// Defer custom.js loading until after page is interactive
(function() {
  let customJsLoaded = false;
  function loadCustomJs() {
    if (customJsLoaded) return;
    customJsLoaded = true;
    const script = document.createElement('script');
    script.src = '//froyaorganics.com/cdn/shop/t/207/assets/custom.js?v=98423137273886370261781701310';
    script.defer = true;
    document.head.appendChild(script);
  }
  
  // Wait for page to be fully loaded and interactive before loading custom.js
  if (document.readyState === 'complete') {
    // Use requestIdleCallback if available
    if ('requestIdleCallback' in window) {
      requestIdleCallback(loadCustomJs, { timeout: 3000 });
    } else {
      setTimeout(loadCustomJs, 3000);
    }
  } else {
    window.addEventListener('load', function() {
      if ('requestIdleCallback' in window) {
        requestIdleCallback(loadCustomJs, { timeout: 3000 });
      } else {
        setTimeout(loadCustomJs, 3000);
      }
    }, { passive: true, once: true });
  }
  
  // Only load on user interaction as fallback - use single delegated listener for better INP
  if (!window._customJsListenerAdded) {
    window._customJsListenerAdded = true;
    document.addEventListener('click', loadCustomJs, { passive: true, once: true });
    document.addEventListener('touchstart', loadCustomJs, { passive: true, once: true });
  }
})();

}catch(e){if(window.console)console.warn('bundled script error',e);}})();
;
(function(){try{

window.shopCurrency = "USD";

}catch(e){if(window.console)console.warn('bundled script error',e);}})();
;
(function(){try{

  window._template = {
    directory: null,
    name: "page",
    suffix: "4-step-routine-anti-age"
  };
  window.__productIdFromTemplate = null;
  window.__plpCollectionIdFromTemplate = null;
  window.igProductData = (function() {
    var data = {};return data;
  })();

}catch(e){if(window.console)console.warn('bundled script error',e);}})();
;
(function(){try{
window.performance && window.performance.mark && window.performance.mark('shopify.content_for_header.start');
}catch(e){if(window.console)console.warn('bundled script error',e);}})();
;
(function(){try{
var Shopify = Shopify || {};
Shopify.shop = "volantaromaeu.myshopify.com";
Shopify.locale = "en";
Shopify.currency = {"active":"USD","rate":"1.0"};
Shopify.country = "US";
Shopify.theme = {"name":"FROYA - LIVE (GitHub)","id":185750618479,"schema_name":"Focal","schema_version":"9.1.0","theme_store_id":null,"role":"main"};
Shopify.theme.handle = "null";
Shopify.theme.style = {"id":null,"handle":null};
Shopify.cdnHost = "froyaorganics.com/cdn";
Shopify.routes = Shopify.routes || {};
Shopify.routes.root = "/";
Shopify.shopJsCdnBaseUrl = "https://cdn.shopify.com/shopifycloud/shop-js";
Shopify.SignInWithShop = Shopify.SignInWithShop || {};
Shopify.SignInWithShop.User = Shopify.SignInWithShop.User || {};
Shopify.SignInWithShop.User.recognized = false;
}catch(e){if(window.console)console.warn('bundled script error',e);}})();
;
(function(){try{
!function(o){function n(){var o=[];function n(){o.push(Array.prototype.slice.apply(arguments))}return n.q=o,n}var t=o.Shopify=o.Shopify||{};t.loadFeatures=n(),t.autoloadFeatures=n()}(window);
}catch(e){if(window.console)console.warn('bundled script error',e);}})();
;
(function(){try{

  window.ShopifyPay = window.ShopifyPay || {};
  window.ShopifyPay.apiHost = "shop.app\/pay";
  window.ShopifyPay.redirectState = "pending";

}catch(e){if(window.console)console.warn('bundled script error',e);}})();
;
(function(){try{

  window.Shopify = window.Shopify || {};
  window.Shopify.SignInWithShop = window.Shopify.SignInWithShop || {};
  window.Shopify.SignInWithShop.assetMetrics = { sampleRate: 0.01 };
  window.Shopify.SignInWithShop.eligible = true;

}catch(e){if(window.console)console.warn('bundled script error',e);}})();
;
(function(){try{

  window.Shopify = window.Shopify || {};
  if (!window.Shopify.featureAssets) window.Shopify.featureAssets = {};
  window.Shopify.featureAssets['shop-js'] = {"shop-toast-manager":["modules/v2/loader.shop-toast-manager.en.esm.js"],"shop-cash-offers":["modules/v2/loader.shop-cash-offers.en.esm.js"],"init-shop-user-recognition":["modules/v2/loader.init-shop-user-recognition.en.esm.js"],"shop-button":["modules/v2/loader.shop-button.en.esm.js"],"init-fed-cm":["modules/v2/loader.init-fed-cm.en.esm.js"],"init-windoid":["modules/v2/loader.init-windoid.en.esm.js"],"listener":["modules/v2/loader.listener.en.esm.js"],"init-shop-cart-sync":["modules/v2/loader.init-shop-cart-sync.en.esm.js"],"avatar":["modules/v2/loader.avatar.en.esm.js"],"init-shop-email-lookup-coordinator":["modules/v2/loader.init-shop-email-lookup-coordinator.en.esm.js"],"init-customer-accounts-sign-up":["modules/v2/loader.init-customer-accounts-sign-up.en.esm.js"],"checkout-modal":["modules/v2/loader.checkout-modal.en.esm.js"],"init-shop-for-new-customer-accounts":["modules/v2/loader.init-shop-for-new-customer-accounts.en.esm.js"],"init-customer-accounts":["modules/v2/loader.init-customer-accounts.en.esm.js"],"shop-login-button":["modules/v2/loader.shop-login-button.en.esm.js"],"shop-user-recognition":["modules/v2/loader.shop-user-recognition.en.esm.js"],"pay-button":["modules/v2/loader.pay-button.en.esm.js"],"shop-cart-sync":["modules/v2/loader.shop-cart-sync.en.esm.js"],"shop-follow-button":["modules/v2/loader.shop-follow-button.en.esm.js"],"shop-login":["modules/v2/loader.shop-login.en.esm.js"],"lead-capture":["modules/v2/loader.lead-capture.en.esm.js"],"payment-terms":["modules/v2/loader.payment-terms.en.esm.js"]};

}catch(e){if(window.console)console.warn('bundled script error',e);}})();
;
(function(){try{
var __st={"a":47399993493,"offset":-14400,"reqid":"080fad13-eb55-431a-ad2e-d9c1807fe59c-1782864970","pageurl":"froyaorganics.com\/pages\/4-step-routine-anti-age-system","s":"pages-704247824751","u":"f71de1ec5afa","p":"page","rtyp":"page","rid":704247824751};
}catch(e){if(window.console)console.warn('bundled script error',e);}})();
;
(function(){try{
window.ShopifyPaypalV4VisibilityTracking = true;
}catch(e){if(window.console)console.warn('bundled script error',e);}})();
;
(function(){try{
!function(){'use strict';const t='contact',e='account',n='new_comment',o=[[t,t],['blogs',n],['comments',n],[t,'customer']],c=[[e,'customer_login'],[e,'guest_login'],[e,'recover_customer_password'],[e,'create_customer']],r=t=>t.map((([t,e])=>`form[action*='/${t}']:not([data-nocaptcha='true']) input[name='form_type'][value='${e}']`)).join(','),a=t=>()=>t?[...document.querySelectorAll(t)].map((t=>t.form)):[];function s(){const t=[...o],e=r(t);return a(e)}const i='password',u='form_key',d=['recaptcha-v3-token','g-recaptcha-response','h-captcha-response',i],f=()=>{try{return window.sessionStorage}catch{return}},m='__shopify_v',_=t=>t.elements[u];function p(t,e,n=!1){try{const o=window.sessionStorage,c=JSON.parse(o.getItem(e)),{data:r}=function(t){const{data:e,action:n}=t;return t[m]||n?{data:e,action:n}:{data:t,action:n}}(c);for(const[e,n]of Object.entries(r))t.elements[e]&&(t.elements[e].value=n);n&&o.removeItem(e)}catch(o){console.error('form repopulation failed',{error:o})}}const l='form_type',E='cptcha';function T(t){t.dataset[E]=!0}const w=window,h=w.document,L='Shopify',v='ce_forms',y='captcha';let A=!1;((t,e)=>{const n=(g='f06e6c50-85a8-45c8-87d0-21a2b65856fe',I='https://cdn.shopify.com/shopifycloud/storefront-forms-hcaptcha/ce_storefront_forms_captcha_hcaptcha.v1.5.2.iife.js',D={infoText:'Protected by hCaptcha',privacyText:'Privacy',termsText:'Terms'},(t,e,n)=>{const o=w[L][v],c=o.bindForm;if(c)return c(t,g,e,D).then(n);var r;o.q.push([[t,g,e,D],n]),r=I,A||(h.body.append(Object.assign(h.createElement('script'),{id:'captcha-provider',async:!0,src:r})),A=!0)});var g,I,D;w[L]=w[L]||{},w[L][v]=w[L][v]||{},w[L][v].q=[],w[L][y]=w[L][y]||{},w[L][y].protect=function(t,e){n(t,void 0,e),T(t)},Object.freeze(w[L][y]),function(t,e,n,w,h,L){const[v,y,A,g]=function(t,e,n){const i=e?o:[],u=t?c:[],d=[...i,...u],f=r(d),m=r(i),_=r(d.filter((([t,e])=>n.includes(e))));return[a(f),a(m),a(_),s()]}(w,h,L),I=t=>{const e=t.target;return e instanceof HTMLFormElement?e:e&&e.form},D=t=>v().includes(t);t.addEventListener('submit',(t=>{const e=I(t);if(!e)return;const n=D(e)&&!e.dataset.hcaptchaBound&&!e.dataset.recaptchaBound,o=_(e),c=g().includes(e)&&(!o||!o.value);(n||c)&&t.preventDefault(),c&&!n&&(function(t){try{if(!f())return;!function(t){const e=f();if(!e)return;const n=_(t);if(!n)return;const o=n.value;o&&e.removeItem(o)}(t);const e=Array.from(Array(32),(()=>Math.random().toString(36)[2])).join('');!function(t,e){_(t)||t.append(Object.assign(document.createElement('input'),{type:'hidden',name:u})),t.elements[u].value=e}(t,e),function(t,e){const n=f();if(!n)return;const o=[...t.querySelectorAll(`input[type='${i}']`)].map((({name:t})=>t)),c=[...d,...o],r={};for(const[a,s]of new FormData(t).entries())c.includes(a)||(r[a]=s);n.setItem(e,JSON.stringify({[m]:1,action:t.action,data:r}))}(t,e)}catch(e){console.error('failed to persist form',e)}}(e),e.submit())}));const S=(t,e)=>{t&&!t.dataset[E]&&(n(t,e.some((e=>e===t))),T(t))};for(const o of['focusin','change'])t.addEventListener(o,(t=>{const e=I(t);D(e)&&S(e,y())}));const B=e.get('form_key'),M=e.get(l),P=B&&M;t.addEventListener('DOMContentLoaded',(()=>{const t=y();if(P)for(const e of t)e.elements[l].value===M&&p(e,B);[...new Set([...A(),...v().filter((t=>'true'===t.dataset.shopifyCaptcha))])].forEach((e=>S(e,t)))}))}(h,new URLSearchParams(w.location.search),n,t,e,['guest_login'])})(!0,!0)}();
}catch(e){if(window.console)console.warn('bundled script error',e);}})();
;
(function(){try{
(function () {var userAgent = navigator.userAgent;var platform = navigator.platform;var maxTouchPoints = navigator.maxTouchPoints || 0;var isIOS = /iPad|iPhone|iPod/.test(platform) || (platform === 'MacIntel' && maxTouchPoints > 1);var isMacSafari = platform.indexOf('Mac') === 0 && /Safari/.test(userAgent) && !/Chrome|Chromium|CriOS|FxiOS|Edg|OPR|Android/.test(userAgent);var isAppleSafari = isIOS || isMacSafari;if (isAppleSafari) {fetch('/sf_private_access_tokens' + location.search).catch(function () {});}function browserMajorVersion(pattern) {var match = userAgent.match(pattern);return match ? parseInt(match[1], 10) : null;}function shouldLoadAutosizesPolyfill() {if (!window.PerformanceObserver?.supportedEntryTypes?.includes('paint')) {return false;}var chromeVersion = browserMajorVersion(/Chrome\/(\d+)/);if (chromeVersion !== null) {return chromeVersion < 126;}var firefoxVersion = browserMajorVersion(/Firefox\/(\d+)/);if (firefoxVersion !== null) {return firefoxVersion < 150;}var safariVersion = isAppleSafari ? browserMajorVersion(/Version\/(\d+).*Safari\//) : null;if (safariVersion !== null) {return safariVersion < 27;}return true;}if (shouldLoadAutosizesPolyfill()) {var autosizesScript = document.createElement('script');autosizesScript.async = true;autosizesScript.crossOrigin = 'anonymous';autosizesScript.src = "//froyaorganics.com/cdn/shopifycloud/storefront/assets/storefront/autosizes-84416378.js";(document.head || document.documentElement).appendChild(autosizesScript);}window.ShopifyAnalytics = window.ShopifyAnalytics || {};window.ShopifyAnalytics.performance = window.ShopifyAnalytics.performance || {};(function () {var LONG_FRAME_THRESHOLD = 50;var longAnimationFrames = [];var activeRafId = null;function collectLongFrames() {var previousTime = null;function rafMonitor(now) {if (activeRafId === null) {return;}var delta = now - previousTime;if (delta > LONG_FRAME_THRESHOLD) {longAnimationFrames.push({startTime: previousTime,endTime: now,});}previousTime = now;activeRafId = requestAnimationFrame(rafMonitor);}previousTime = performance.now();activeRafId = requestAnimationFrame(rafMonitor);}if (!window.PerformanceObserver?.supportedEntryTypes?.includes('long-animation-frame')) {collectLongFrames();var timeoutId = setTimeout(function () {cancelAnimationFrame(activeRafId);}, 10000);window.ShopifyAnalytics.performance.getLongAnimationFrames = function (stopCollection) {if (stopCollection === undefined) {stopCollection = false;}if (stopCollection) {clearTimeout(timeoutId);cancelAnimationFrame(activeRafId);}return longAnimationFrames;};}})();})();
}catch(e){if(window.console)console.warn('bundled script error',e);}})();
;
(function(){try{
var Shopify=Shopify||{};Shopify.PaymentButton=Shopify.PaymentButton||{isStorefrontPortableWallets:!0,init:function(){window.Shopify.PaymentButton.init=function(){};var t=document.createElement("script");t.src="https://froyaorganics.com/cdn/shopifycloud/portable-wallets/latest/portable-wallets.en.js",t.type="module",document.head.appendChild(t)}};

}catch(e){if(window.console)console.warn('bundled script error',e);}})();
;
(function(){try{

  function portableWalletsHideBuyerConsent(e){var t=document.getElementById("shopify-buyer-consent"),n=document.getElementById("shopify-subscription-policy-button");t&&n&&(t.classList.add("hidden"),t.setAttribute("aria-hidden","true"),n.removeEventListener("click",e))}function portableWalletsShowBuyerConsent(e){var t=document.getElementById("shopify-buyer-consent"),n=document.getElementById("shopify-subscription-policy-button");t&&n&&(t.classList.remove("hidden"),t.removeAttribute("aria-hidden"),n.addEventListener("click",e))}window.Shopify?.PaymentButton&&(window.Shopify.PaymentButton.hideBuyerConsent=portableWalletsHideBuyerConsent,window.Shopify.PaymentButton.showBuyerConsent=portableWalletsShowBuyerConsent);

}catch(e){if(window.console)console.warn('bundled script error',e);}})();
;
(function(){try{
document.addEventListener("DOMContentLoaded",(function(){function t(){return document.querySelector("shopify-accelerated-checkout-cart, shopify-accelerated-checkout")}if(t())Shopify.PaymentButton.init();else{new MutationObserver((function(e,n){t()&&(Shopify.PaymentButton.init(),n.disconnect())})).observe(document.body,{childList:!0,subtree:!0})}}));

}catch(e){if(window.console)console.warn('bundled script error',e);}})();
;
(function(){try{
window.performance && window.performance.mark && window.performance.mark('shopify.content_for_header.end');
}catch(e){if(window.console)console.warn('bundled script error',e);}})();
;
(function(){try{

(function() {
  const blockedResources = [
    'shop.app',
    'accelerated-checkout',
    'portable-wallets',
    'shopifycloud/portable-wallets'
  ];
  
  function removeUnwantedResources() {
    // Use for...of instead of forEach for better performance
    const links = document.querySelectorAll('link');
    for (const link of links) {
      const href = link.href || '';
      if (blockedResources.some(function(blocked) { return href.includes(blocked); })) {
        if (href.includes('accelerated-checkout') || href.includes('portable-wallets')) {
          const originalHref = href;
          link.remove();
          setTimeout(function() {
            const newLink = document.createElement('link');
            newLink.rel = 'stylesheet';
            newLink.href = originalHref;
            newLink.crossOrigin = 'anonymous';
            document.head.appendChild(newLink);
          }, 5000);
        } else {
          link.remove();
        }
      }
    }
  }
  
  removeUnwantedResources();
  
  if (window.MutationObserver) {
    let mutationTimeout;
    let mutationCount = 0;
    const maxMutations = 5;
    let isProcessing = false;
    
    const processMutations = function(mutations) {
      if (isProcessing || mutationCount >= maxMutations) return;
      isProcessing = true;
      
      for (const mutation of mutations) {
        if (mutationCount >= maxMutations) break;
        
        for (const node of mutation.addedNodes) {
          if (mutationCount >= maxMutations) break;
          if (node.nodeType !== 1 || node.tagName !== 'LINK') continue;
          
          const href = node.href || '';
          if (!blockedResources.some(function(blocked) { return href.includes(blocked); })) continue;
          
          if (href.includes('accelerated-checkout') || href.includes('portable-wallets')) {
            const originalHref = href;
            node.remove();
            setTimeout(function() {
              const newLink = document.createElement('link');
              newLink.rel = 'stylesheet';
              newLink.href = originalHref;
              newLink.crossOrigin = 'anonymous';
              document.head.appendChild(newLink);
            }, 5000);
          } else {
            node.remove();
          }
          mutationCount++;
        }
      }
      
      isProcessing = false;
    };
    
    const observer = new MutationObserver(function(mutations) {
      clearTimeout(mutationTimeout);
      mutationTimeout = setTimeout(function() {
        if ('requestIdleCallback' in window) {
          requestIdleCallback(function() {
            processMutations(mutations);
          }, { timeout: 100 });
        } else {
          processMutations(mutations);
        }
      }, 300);
    });
    
    setTimeout(function() {
      observer.observe(document.head, { childList: true });
      setTimeout(function() {
        observer.disconnect();
      }, 3000);
    }, 1000);
  }
})();

}catch(e){if(window.console)console.warn('bundled script error',e);}})();
;
(function(){try{

  var _support = _support || { 'ui': {}, 'user': {} };
  _support.account = "vossabia";

}catch(e){if(window.console)console.warn('bundled script error',e);}})();
;
(function(){try{

window.$th_bundle_addtocart_callback = function(){
  fetch("/cart.js")
    .then(function(res) { return res.json(); })
    .then(function(cart) {
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:refresh', {
          bubbles: true,
          detail: { cart: cart, openMiniCart: true }
        })
      );
    });
}

}catch(e){if(window.console)console.warn('bundled script error',e);}})();
;
(function(){try{

(function () {
  'use strict';
  if (window.__consentmoDataSrcBootstrapInit) return;
  window.__consentmoDataSrcBootstrapInit = true;

  function activateConsentmoDataSrcScripts() {
    if (!window.Shopify || !window.Shopify.shop) return;
    document.querySelectorAll('script[data-src*="consentmo_cookie_consent"]').forEach(function (scriptEl) {
      if (scriptEl.src) return;
      var url = scriptEl.getAttribute('data-src');
      if (url) scriptEl.src = url;
    });
  }
  function scheduleActivation() {
    activateConsentmoDataSrcScripts();
    // Retry on next task so other DCL handlers (lazy-loaders) can finish setting Shopify.shop / data-src first.
    setTimeout(activateConsentmoDataSrcScripts, 0);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleActivation, { once: true });
  } else {
    scheduleActivation();
  }
})();

}catch(e){if(window.console)console.warn('bundled script error',e);}})();
;
(function(){try{

!function(s) {
  let o = s.createElement('script'), u = s.getElementsByTagName('script')[0];
  o.src = 'https://cdn.aggle.net/oir/oir.min.js';
  o.async = !0, o.setAttribute('oirtyp', '48b1feaa'), o.setAttribute('oirid', 'P7P987M69');
  u.parentNode.insertBefore(o, u);
}(document);

}catch(e){if(window.console)console.warn('bundled script error',e);}})();
;
(function(){try{

  {
    const cleanObj = (value) => {
      if (Array.isArray(value)) {
        const cleanedArray = value.map(cleanObj).filter((v) => v !== undefined);
        return cleanedArray.length ? cleanedArray : undefined;
      }
      if (value && typeof value === "object") {
        const cleanedObject = Object.entries(value).reduce((acc, [key, val]) => {
          const cleanedValue = cleanObj(val);
          if (cleanedValue !== undefined && cleanedValue !== null && cleanedValue !== "") {
            acc[key] = cleanedValue;
          }
          return acc;
        }, {});
        return Object.keys(cleanedObject).length ? cleanedObject : undefined;
      }
      if (value === null || value === undefined || value === "") {
        return undefined;
      }
      return value;
    };
    const getCustomer = () => ({
      shopifyCustomerId: "",
      email: "",
      phone: "",
      first_name: null,
      last_name: null,
      lifetime_value: null,
      order_count: null,
      address: {
        street: null,
        city: null,
        state:  null,
        stateCode: null,
        postalCode: "",
        country: "",
        province: "",
        countryCode: "",
      }
    });
    
  }

}catch(e){if(window.console)console.warn('bundled script error',e);}})();
;
(function(){try{
function sendEvent(){window?.__igce && window.__igce("javascriptEvent", "javascripteventOXYGW");}// Focal's hamburger opens the drawer on `pointerup` (capture) and stops
// propagation, so a plain click never reliably fires. Listen on pointerup in
// the CAPTURE phase at document level — that runs BEFORE the theme's own
// handler, so we always catch it.
document.addEventListener("pointerup", function (event) {
  // Control only — legacy header is hidden for variant B.
  if (document.documentElement.classList.contains("ig-nav-b")) return;

  var btn = event.target.closest && event.target.closest('[aria-controls="mobile-menu-drawer"]');
  if (!btn) return;

  window.igEvents = window.igEvents || [];
  window.igEvents.push({
    "event": "javascripteventOXYGW"
  });
}, true);

}catch(e){if(window.console)console.warn('bundled script error',e);}})();
;
(function(){try{
function sendEvent(){window?.__igce && window.__igce("javascriptEvent", "javascripteventOOQEA");}(function () {
  var EXP = '38bab628-6516-4b23-9610-9cd3283bc713', GROUP = '074094ef-3562-4012-a95f-9b1905e11951'; // Control Group
  function gid(){try{var v=window.igData?.user?.getTestGroup?.(EXP);return (v&&v.id)?v.id:(v||'');}catch(e){return'';}}
  document.addEventListener('openable-element:open', function (e) {
    if (!e.target || e.target.id !== 'mini-cart') return;
    if (window.matchMedia('(max-width: 768px)').matches) return;  // desktop (NOT mobile)
    if (gid() !== GROUP) return;                                  // control
    (window.igEvents = window.igEvents || []).push({ event: 'javascripteventOOQEA' });
  });
})();

}catch(e){if(window.console)console.warn('bundled script error',e);}})();
;
(function(){try{
function sendEvent(){window?.__igce && window.__igce("javascriptEvent", "javascripteventCTBJD");}(function () {
  var EXP = '38bab628-6516-4b23-9610-9cd3283bc713', GROUP = '9944d2ab-9bf7-4986-b3cd-220b43d9b789'; // New Group 1
  function gid(){try{var v=window.igData?.user?.getTestGroup?.(EXP);return (v&&v.id)?v.id:(v||'');}catch(e){return'';}}
  document.addEventListener('openable-element:open', function (e) {
    if (!e.target || e.target.id !== 'mini-cart') return;
    if (!window.matchMedia('(max-width: 768px)').matches) return; // mobile
    if (gid() !== GROUP) return;                                  // variant
    (window.igEvents = window.igEvents || []).push({ event: 'javascripteventCTBJD' });
  });
})();

}catch(e){if(window.console)console.warn('bundled script error',e);}})();
;
(function(){try{
function sendEvent(){window?.__igce && window.__igce("javascriptEvent", "javascripteventBJYPM");}(function () {
  var EXP = '38bab628-6516-4b23-9610-9cd3283bc713', GROUP = '9944d2ab-9bf7-4986-b3cd-220b43d9b789'; // New Group 1
  function gid(){try{var v=window.igData?.user?.getTestGroup?.(EXP);return (v&&v.id)?v.id:(v||'');}catch(e){return'';}}
  document.addEventListener('openable-element:open', function (e) {
    if (!e.target || e.target.id !== 'mini-cart') return;
    if (window.matchMedia('(max-width: 768px)').matches) return;  // desktop (NOT mobile)
    if (gid() !== GROUP) return;                                  // variant
    (window.igEvents = window.igEvents || []).push({ event: 'javascripteventBJYPM' });
  });
})();

}catch(e){if(window.console)console.warn('bundled script error',e);}})();
;
(function(){try{
function sendEvent(){window?.__igce && window.__igce("javascriptEvent", "javascripteventIDLSR");}(function () {
  var EXP = '38bab628-6516-4b23-9610-9cd3283bc713', GROUP = '074094ef-3562-4012-a95f-9b1905e11951'; // Control Group
  function gid(){try{var v=window.igData?.user?.getTestGroup?.(EXP);return (v&&v.id)?v.id:(v||'');}catch(e){return'';}}
  document.addEventListener('openable-element:open', function (e) {
    if (!e.target || e.target.id !== 'mini-cart') return;
    if (!window.matchMedia('(max-width: 768px)').matches) return; // mobile
    if (gid() !== GROUP) return;                                  // control
    (window.igEvents = window.igEvents || []).push({ event: 'javascripteventIDLSR' });
  });
})();

}catch(e){if(window.console)console.warn('bundled script error',e);}})();
;
(function(){try{
function sendEvent(){window?.__igce && window.__igce("javascriptEvent", "javascripteventHEAXK");}document.addEventListener("mouseover", function (event) {
  // Control only — the old nav is hidden for variant B, so this guard makes
  // sure the event is never attributed to a variant-B visitor.
  if (document.documentElement.classList.contains("ig-nav-b")) return;

  // Top-level old-nav items (Anti-Age System / Hair & Scalp Care /
  // Stop Dry Itchy Skin / More) plus the standalone SHOP ALL button.
  // The "> " child combinator excludes the mega-menu sub-links inside "More",
  // keeping this comparable with the variant-B top-level hover tracker.
  var item =
    event.target.closest &&
    event.target.closest(".header__linklist-item > .header__linklist-link, .button-shop-all");
  if (!item) return;

  // mouseover re-fires over child elements; count one hover per entry.
  if (window.__froyaNavHoverControl === item) return;
  window.__froyaNavHoverControl = item;

  window.igEvents = window.igEvents || [];
  window.igEvents.push({
    "event": "javascripteventHEAXK"
  });
});

// Reset when the cursor truly leaves the item, so a later re-hover counts.
document.addEventListener("mouseout", function (event) {
  if (window.__froyaNavHoverControl && !window.__froyaNavHoverControl.contains(event.relatedTarget)) {
    window.__froyaNavHoverControl = null;
  }
});

}catch(e){if(window.console)console.warn('bundled script error',e);}})();
;
(function(){try{
function sendEvent(){window?.__igce && window.__igce("javascriptEvent", "javascripteventLARZL");}document.addEventListener("mouseover", function (event) {
  // Variant B only — the new nav is hidden for control, so this guard makes
  // sure the event is never attributed to a control visitor.
  if (!document.documentElement.classList.contains("ig-nav-b")) return;

  // Only the top-level menu items: Shop / Bestsellers / More.
  var item = event.target.closest && event.target.closest(".froya-nav__nav-link[data-mega-target]");
  if (!item) return;

  // mouseover re-fires over child elements; count one hover per entry.
  if (window.__froyaNavHover === item) return;
  window.__froyaNavHover = item;

  window.igEvents = window.igEvents || [];
  window.igEvents.push({
    "event": "javascripteventLARZL" // keep YOUR generated identifier
  });
});

// Reset when the cursor truly leaves the item, so a later re-hover counts.
document.addEventListener("mouseout", function (event) {
  if (window.__froyaNavHover && !window.__froyaNavHover.contains(event.relatedTarget)) {
    window.__froyaNavHover = null;
  }
});

}catch(e){if(window.console)console.warn('bundled script error',e);}})();
;
(function(){try{

        window['__cvg_shopify_info'] = {
          product: null,
          variant: null,
          currency: "USD",
          collection: {...null, products: null},
          search: null,
        };
      
}catch(e){if(window.console)console.warn('bundled script error',e);}})();
;
(function(){try{

        window.cvg||(cvg=function(){cvg.process?cvg.process.apply(cvg,arguments):cvg.queue.push(arguments)},cvg.queue=[]);
        cvg({method:"track",eventName:"$page_load"});
      
}catch(e){if(window.console)console.warn('bundled script error',e);}})();
;
(function(){try{

        window.ALBSS = {
            event_key: '«your-event-key»'
        };
        
}catch(e){if(window.console)console.warn('bundled script error',e);}})();
;
(function(){try{
document.addEventListener('DOMContentLoaded',function(){document.querySelectorAll('.s-main-product__faq-item').forEach(function(it){it.classList.remove('rf-open');var t=it.querySelector('.s-main-product__faq-title');if(t){t.addEventListener('click',function(e){e.stopPropagation();it.classList.toggle('rf-open');},true);}});});
}catch(e){if(window.console)console.warn('bundled script error',e);}})();
;
(function(){try{
(function(){function fx(){document.querySelectorAll('c-subscription label').forEach(function(l){var n=(l.textContent||'').toLowerCase();var m=l.querySelector('.js-subscribtion__main-price');var c=l.querySelector('.js-subscribtion__compare-at-price');if(n.indexOf('subscribe')>-1){if(m&&m.textContent.trim()!=='$59')m.textContent='$59';if(c&&c.textContent.trim()!=='$79')c.textContent='$79';}else if(n.indexOf('one')>-1&&n.indexOf('time')>-1){if(m&&m.textContent.trim()!=='$79')m.textContent='$79';if(c&&c.textContent.trim()!=='$99')c.textContent='$99';}});var sel=document.querySelector('c-subscription input:checked');var pr='$59';if(sel){var lb=sel.closest('label');if(lb&&/one.?time/i.test(lb.textContent))pr='$79';}document.querySelectorAll('.c-subscribtion__price').forEach(function(b){if(!/original/.test(b.className)&&/\$/.test(b.textContent)&&b.textContent.trim()!==pr)b.textContent=pr;});document.querySelectorAll('c-subscription strong,c-subscription li,c-subscription span').forEach(function(e){if(e.children.length===0&&/40\s*days/i.test(e.textContent))e.textContent=e.textContent.replace(/40\s*days/i,'30 days');});}function bt(){fx();var c=document.querySelector('c-subscription');if(c){new MutationObserver(fx).observe(c,{childList:true,subtree:true,characterData:true});c.addEventListener('change',fx,true);c.addEventListener('click',function(){setTimeout(fx,60);},true);}[150,500,1200,2500].forEach(function(t){setTimeout(fx,t);});}if(document.readyState!=='loading')bt();else document.addEventListener('DOMContentLoaded',bt);})();
}catch(e){if(window.console)console.warn('bundled script error',e);}})();
;
(function(){try{
window.rfAddToCart=function(btn){try{var sel=document.querySelector('input[name="purchase_type"]:checked');var sub=sel?sel.value==='subscription':true;var item={id:58126099710112,quantity:1};if(sub){item.selling_plan=9530179744;}if(btn){btn.disabled=true;btn.style.opacity=0.7;}fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[item]})}).then(function(r){if(!r.ok){return r.json().then(function(e){throw new Error(e.description||'Could not add to cart');});}return r.json();}).then(function(){window.location.href='/checkout';}).catch(function(err){if(btn){btn.disabled=false;btn.style.opacity=1;}alert('Sorry, we could not add this to your cart. '+(err&&err.message||''));});}catch(e){if(btn){btn.disabled=false;btn.style.opacity=1;}}};
}catch(e){if(window.console)console.warn('bundled script error',e);}})();